var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGiftSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.854,
    height: 33.854,
    viewBox: "0 0 33.854 33.854",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gift-solid",
    d: "M10.051,0H10.2a5.964,5.964,0,0,1,5.138,2.939l1.594,2.712,1.594-2.712A5.964,5.964,0,0,1,23.658,0H23.8a5.819,5.819,0,0,1,5.819,5.819,6.015,6.015,0,0,1-.635,2.645h2.751a2.114,2.114,0,0,1,2.116,2.116v4.232a2.114,2.114,0,0,1-2.116,2.116H2.116A2.115,2.115,0,0,1,0,14.811V10.58A2.115,2.115,0,0,1,2.116,8.464H4.867a5.979,5.979,0,0,1-.635-2.645A5.819,5.819,0,0,1,10.051,0ZM12.6,4.548a2.79,2.79,0,0,0-2.4-1.374h-.145a2.645,2.645,0,0,0,0,5.29H14.9ZM23.8,3.174h-.145a2.79,2.79,0,0,0-2.4,1.374l-2.3,3.916H23.8a2.645,2.645,0,1,0,0-5.29ZM2.116,19.043h12.7V33.854H5.29a3.174,3.174,0,0,1-3.174-3.174ZM19.043,33.854V19.043h12.7V30.681a3.175,3.175,0,0,1-3.174,3.174Z",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGiftSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gift-solid.01810fe04a24b42ee3e50ca050f3f6a2.svg";